import { Module } from 'vuex-smart-module';
import DispatchesActions from './actions';
import DispatchesGetters from './getters';
import DispatchesMutations from './mutations';
import DispatchesState from './state';

export default new Module({
  state: DispatchesState,
  mutations: DispatchesMutations,
  actions: DispatchesActions,
  getters: DispatchesGetters,
});
